<template>
  <div>
    <p>観光中に立ち寄り先を選択する際に、混雑している施設を避けることに心がけをしていますか？</p>
    <SelectText :item-list=lateList @select-text="onSelectText" />
  </div>
</template>

<script>
import { LATE_LIST } from '../../const.js'
import SelectText from '@/components/Molecules/SelectText'

export default {
  name: 'input-late',
  components: {
    SelectText
  },
  computed: {
    lateList () { return LATE_LIST }
  },
  methods: {
    onSelectText (e) {
      this.$emit('select-text', e)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import './../../unified.scss';

</style>



// WEBPACK FOOTER //
// src/components/Organisms/InputLate.vue